import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  FormGroup,
  NonNullableFormBuilder,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-login-layout',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './login-layout.component.html',
  styleUrls: ['./login-layout.component.css'],
})
export class LoginLayoutComponent {
  @Input() usuarioTipo: string = 'Usuario';
  @Input() errorMessage: string | null = null;

  @Output() onSubmit = new EventEmitter<{ userName: string; password: string }>();

  validateForm: FormGroup;

  constructor(private fb: NonNullableFormBuilder) {
    this.validateForm = this.fb.group({
      userName: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
  }

  submitForm(): void {
    if (this.validateForm.valid) {
      const { userName, password } = this.validateForm.value;
      this.onSubmit.emit({ userName, password }); // Emitir los datos al componente padre
    }
  }
}

